// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2b1bf271","453":"5565870f","455":"a5d29221"}[chunkId] + ".chunk.js";
};